"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BufferController = function () {
    function BufferController(isoFile) {
        _classCallCheck(this, BufferController);

        this.ISOFile = isoFile;
        this.VideoBox = isoFile.boxes[0];
        this.CurrentSegmentIndex = 0;
        this.LastLoadedSegmentIndex = 0;
        this.NextSegmentIndex = 0;
        this.IsFetching = false;
        this.FirstSegmentLoaded = false;
        this.PreSegmentNumber = 5;
        this.LoadingSegment = null;
        this.QueueLoadEvent = [];
        this.CurrentLoadSegmentIndex = null;
    }

    /**
     * 根据时间节点计算出该时间所在的切片位置 并返回所在切片的号码
     * @param VideoBoxs
     * @param time
     * @returns {*}
     */


    _createClass(BufferController, [{
        key: "calculateSegmentIndexForTime",
        value: function calculateSegmentIndexForTime(time) {
            var VcalculateTime = void 0,
                Vtimescale = void 0,
                SegmentIndex = void 0;
            Vtimescale = this.VideoBox.timescale;
            VcalculateTime = 0;
            for (var i = 0; i < this.VideoBox.references.length; i++) {
                VcalculateTime += this.VideoBox.references[i].subsegment_duration / Vtimescale;
                if (VcalculateTime >= time) {
                    SegmentIndex = i;
                    break;
                }
            }
            return SegmentIndex;
        }

        /**
         * 根据视频分片的下标号 计算出该该分片所要求的字节范围
         * @param initRange
         * @param SegmentIndex
         * @returns {{start: *, end: *}}
         */

    }, {
        key: "calculateRequestRangeForIndex",
        value: function calculateRequestRangeForIndex(initRange, SegmentIndex) {
            var RangeStart = void 0,
                RangeEnd = void 0;
            RangeStart = initRange.start;
            RangeEnd = initRange.end;
            for (var i = 0; i <= SegmentIndex; i++) {
                RangeStart = RangeEnd + 1;
                RangeEnd += this.VideoBox.references[i].referenced_size;
            }
            return {
                start: RangeStart,
                end: RangeEnd
            };
        }
    }]);

    return BufferController;
}();

exports.default = BufferController;


//////////////////
// WEBPACK FOOTER
// ./~/somi-dashjs/dist/BufferController.js
// module id = 17
// module chunks = 0